export default {
    appLogin({}, payload) {
        const { fullName, token } = payload
        localStorage.setItem('ucf_loggedUser', fullName)
        localStorage.setItem('ucf_token', token)
    },
    appLogout() {
        localStorage.removeItem('ucf_loggedUser')
        localStorage.removeItem('ucf_token')
    },
    updateProfile({}, payload) {
        const { fullName } = payload
        localStorage.setItem('ucf_loggedUser', fullName)
    },
    appLoading({ commit }, isLoading) {
        commit('setLoading', isLoading);
    }
}